import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { chungChiChungNhanApi } from "../../../api/chung-nhan-chung-chi/chungChiChungNhanApi";
import { rootActions } from "../../actions/rootActions";
import { eChungChiChungNhanActionIds, IChungChiChungNhanActionTypes } from "../../action-types/chung-chi-chung-nhan/chungChiChungNhanActions";
import { IChungChiChungNhan } from "../../../model/response/chung-chi-chung-nhan/IChungChiChungNhan";


export function* chungChiChungNhanSaga(): any {
    yield takeLatest(eChungChiChungNhanActionIds.LOAD_START, loadWorker);
    yield takeEvery(eChungChiChungNhanActionIds.SAVE_START, saveWorker);
    yield takeEvery(eChungChiChungNhanActionIds.DELETE_START, deleteWorker);
}


function* loadWorker(): any {
    const res: IBaseResponse = yield call(chungChiChungNhanApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhan.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhan.LOAD_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* saveWorker(action: IChungChiChungNhanActionTypes): any {
    let res: IBaseResponse;
    const data = action.payload as IChungChiChungNhan;
    if (data.id > 0) {
        res = yield call(chungChiChungNhanApi.Update, data.id, data);
    } else {
        res = yield call(chungChiChungNhanApi.Insert, data);
    }
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhan.SAVE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhan.SAVE_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteWorker(action: IChungChiChungNhanActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(chungChiChungNhanApi.Delete, id);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhan.DELETE_SUCCESS(undefined));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhan.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}